module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("GRN List")]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted justify-content-center"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('h4', {
    staticClass: "error"
  }, [_vm._v("\n            Start Date : " + _vm._s(_vm.GRNdate.startDate) + " / End Date : " + _vm._s(_vm.GRNdate.endDate) + "\n          ")])])], 1), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [(_vm.All_GRN_List_data.length > 0) ? _c('b-button', {
    staticClass: "pull-right mr-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports()
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [(_vm.All_GRN_List_data.length > 0) ? _c('b-button', {
    staticClass: "pull-right mr-3",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.exportToExcelClient
    }
  }, [_vm._v("\n              Export (Client XLSX)\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Common Number",
      "id": "common_filter",
      "name": "common_filter"
    },
    on: {
      "input": _vm.filterSearch
    },
    model: {
      value: (_vm.Filter.common_filter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "common_filter", $$v)
      },
      expression: "Filter.common_filter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n            Filters")])], 1)], 1), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.TypeList,
      "id": "clientNamenew",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.Filter.TypeList),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TypeList", $$v)
      },
      expression: "Filter.TypeList"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.Filter.TypeList != '1') ? _c('label', [_vm._v("GRN Date")]) : _c('label', [_vm._v("Assignment Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    model: {
      value: (_vm.GRNdate),
      callback: function($$v) {
        _vm.GRNdate = $$v
      },
      expression: "GRNdate"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Assignment No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Assignment No.",
      "id": "assignmentNo",
      "name": "assignmentNo"
    },
    model: {
      value: (_vm.Filter.assignmentNo),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignmentNo", $$v)
      },
      expression: "Filter.assignmentNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("All Module ID")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "All Module Id",
      "id": "allModuleId",
      "name": "allModuleId"
    },
    model: {
      value: (_vm.Filter.allModuleId),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "allModuleId", $$v)
      },
      expression: "Filter.allModuleId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Container Number",
      "id": "Container_number",
      "name": "Container_number"
    },
    model: {
      value: (_vm.Filter.Container_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "Container_number", $$v)
      },
      expression: "Filter.Container_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("GRN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "GRN Number",
      "id": "GRN_number",
      "name": "GRN_number"
    },
    model: {
      value: (_vm.Filter.GRN_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "GRN_number", $$v)
      },
      expression: "Filter.GRN_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Booking Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Booking Number",
      "id": "booking_number",
      "name": "booking_number"
    },
    model: {
      value: (_vm.Filter.booking_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "booking_number", $$v)
      },
      expression: "Filter.booking_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BOE Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "BOE Number",
      "id": "BOE_number",
      "name": "BOE_number"
    },
    model: {
      value: (_vm.Filter.BOE_number),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BOE_number", $$v)
      },
      expression: "Filter.BOE_number"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vehicle No")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllVehicleDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vehicle No"
    },
    model: {
      value: (_vm.Filter.vehicleNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vehicleNoFilter", $$v)
      },
      expression: "Filter.vehicleNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vehicle Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.VehicleStatusList,
      "option-value": "val",
      "option-text": "status",
      "placeholder": "Select Vehicle Status"
    },
    model: {
      value: (_vm.Filter.vehicleStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vehicleStatusFilter", $$v)
      },
      expression: "Filter.vehicleStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Pickup Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPickupList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    model: {
      value: (_vm.Filter.PICKfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PICKfilter", $$v)
      },
      expression: "Filter.PICKfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Handover Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllHandoverList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    model: {
      value: (_vm.Filter.HANDfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "HANDfilter", $$v)
      },
      expression: "Filter.HANDfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Stuffing Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location"
    },
    model: {
      value: (_vm.Filter.STUFFfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "STUFFfilter", $$v)
      },
      expression: "Filter.STUFFfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.Filter.clientIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientIdFilter", $$v)
      },
      expression: "Filter.clientIdFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 row justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search\n              ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.All_GRN_List_data,
      "fields": _vm.fields,
      "primary-key": "goodReceivedID",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "goodReceivedID",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "GRNSeries",
      fn: function(row1) {
        return [_c('span', [_c('b', [_vm._v("GRN Series:")]), _vm._v(" " + _vm._s(row1.item.GRNSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("GRN Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(row1.item.GRNDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("GRN skip:")]), _vm._v(" " + _vm._s(row1.item.skipGRN))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("GRN Counter:")]), _vm._v(" " + _vm._s(row1.item.grnIdNew))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("GRN Type:")]), _vm._v(" " + _vm._s(row1.item.tptType_Status))]), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Transit Status:")]), _vm._v(" " + _vm._s(row1.item.transitStatus))])]
      }
    }, {
      key: "JobNo",
      fn: function(row21) {
        return [_c('b', [_c('b', [_vm._v("Assign Number:")]), _vm._v(" " + _vm._s(row21.item.JobNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_c('b', [_vm._v("Assign Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(row21.item.JobDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_c('b', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row21.item.RaisedFrom))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_c('b', [_vm._v("Rasied By:")]), _vm._v(" " + _vm._s(row21.item.RaisedBy))])]
      }
    }, {
      key: "validBookingNo",
      fn: function(row5) {
        return [_c('span', [_c('b', [_vm._v("Invoice No:")]), _vm._v(" " + _vm._s(row5.item.BillingSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Invoice Date:")]), _vm._v(" " + _vm._s(row5.item.BillingDate))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Invoice Status:")]), _vm._v(" " + _vm._s(row5.item.INV_Status))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Invoice Amount:")]), _vm._v(" " + _vm._s(row5.item.BillingAmount))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Dispatch Date Time:")]), _vm._v(" " + _vm._s(row5.item.vehicleDispatchDateNew))])]
      }
    }, {
      key: "OtherDetails",
      fn: function(row3) {
        return [_c('span', [_c('b', [_vm._v("POL")]), _vm._v(" : " + _vm._s(row3.item.PICK))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Stuff")]), _vm._v(" : " + _vm._s(row3.item.STUFF))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Hand")]), _vm._v(" : " + _vm._s(row3.item.HAND))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_c('b', [_vm._v("Client Name: ")]), _vm._v(_vm._s(row4.item.clientName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Shipping Line: ")]), _vm._v(" " + _vm._s(row4.item.shippingLine))])]
      }
    }, {
      key: "containerDetails",
      fn: function(row6) {
        return [_c('span', [_c('b', [_vm._v("Container No:")]), _vm._v(" " + _vm._s(row6.item.containerNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Multi Container Type:")]), _vm._v(" " + _vm._s(row6.item.multipleContainerType))])]
      }
    }, {
      key: "vehicledetails",
      fn: function(row7) {
        return [_c('span', [_c('b', [_vm._v("Vehicle No: ")]), _vm._v(_vm._s(row7.item.vehicleNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Driver Name: ")]), _vm._v(_vm._s(row7.item.assignedDriverName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Driver Phone No: ")]), _vm._v(_vm._s(row7.item.assignedDriverContact))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Driver Emp Code: ")]), _vm._v(_vm._s(row7.item.Driver_Emp_Code))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Vehicle Release Date Time: ")]), _vm._v(_vm._s(row7.item.vehicleReleaseDateNew))]), _vm._v(" "), _c('b-button', {
          staticClass: "pull-right ml-2",
          attrs: {
            "variant": "outline-info",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.goToMailPage('T', row7.item)
            }
          }
        }, [_vm._v("Track\n              Assignment")])]
      }
    }, {
      key: "action",
      fn: function(row) {
        return [(row.item.pdfGRN) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(row.item.pdfGRN)
            }
          }
        }, [_vm._v("View PDF")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "10",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19fc76d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/expense/GRNdetails.vue
// module id = 2424
// module chunks = 0